export default "__VITE_ASSET__Civv7nFx__"